// extracted by mini-css-extract-plugin
module.exports = {"buttonLoader":"Estimations_buttonLoader__2uWrw","label":"Estimations_label__1N3hx","paragraph":"Estimations_paragraph__EOA7M"};